import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ClinicalExamEntryComponent } from '../clinical-exam-entry/clinical-exam-entry.component';
import { ClinicalExamModel } from 'src/app/models/ClinicalExamModel';
import { ClinicalExamService } from 'src/app/services/ClinicalExamService';
import swal from 'sweetalert2';

@Component({
  selector: 'app-clinical-exam',
  templateUrl: './clinical-exam.component.html',
  styleUrls: ['./clinical-exam.component.css']
})
export class ClinicalExamComponent implements OnInit {
  patientcode = '' ;
  Patientname = '';

  examdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  examlocation = '' ;
  examperfstatus = '' ;
  examnotes = '' ;
  userid = '' ;
  username = '' ;
  wk_font = 2;
  wk_fontsize = '2ch';
  chkuser = '';

  clinicalexamList : ClinicalExamModel[]=[];
  disablepharnacy = false;

  constructor(public clinicalexam: ClinicalExamModel,private dialogref: MatDialog,
              public storage: LocalStorageService,
              public cliniclexamService :ClinicalExamService,
  ) { }

  ngOnInit(): void {
   /////************ */
   this.patientcode = this.storage.retrieve('stgPatientCode');
   this.Patientname = this.storage.retrieve('stgPatientName');
   this.examdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
   this.RetriveClinicalExam();
   if(this.storage.retrieve('stgGroup') !='2'){this.disablepharnacy = true}else{this.disablepharnacy = false}

  }
  ZoomIn(){
    this.wk_font  = this.wk_font  + 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  ZoomOut(){
    this.wk_font  = this.wk_font  - 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  RetriveClinicalExam(){
    this.clinicalexamList = [];
    this.cliniclexamService.getClinicalExamPatient(this.patientcode).subscribe((data: ClinicalExamModel[]) => {
          for (let i = 0; i < data.length; i++) {
            this.clinicalexamList[i] = data[i];
            this.clinicalexamList[i].examdate =formatDate(data[i].examdate, 'yyyy-MM-dd', 'en');
          }
        })
  }
EditCliniclExam(item: ClinicalExamModel){
  this.chkuser = item.username;
  if( item.username == this.storage.retrieve('stgusername') )
    {                         ///----------- for searching pop up send variables from table-----------
  this.storage.store('stgPatientCode',item.patientcode);
  this.storage.store('stgVisitDate',item.examdate)
  const dialogRef = this.dialogref.open(ClinicalExamEntryComponent,
    {
      data: {
        dataKey: this.clinicalexam,
      },
      width: '50vw',
      height: '30vw',
    });
  dialogRef.afterClosed().subscribe(result => {
  this. RetriveClinicalExam();
  });

  const dialogSubmitSubscription =
    dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.RetriveClinicalExam();
      dialogSubmitSubscription.unsubscribe();
    });
  }
  else
  {
    this.MesgWarrning();
  }
}
  MesgWarrning(){

    swal({
      title: 'Check User',
      text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
      type: 'warning',
      showCancelButton: false,
      confirmButtonText: 'OK',
      //cancelButtonText: 'No, keep it',
    })
    ;

  }
  DeleteClinicExam(){

    this.cliniclexamService.deleteClinicalExam(this.storage.retrieve('stgVisitDate'),this.storage.retrieve('stgPatientCode'),this.userid).subscribe(
        (data: ClinicalExamModel) => {
          this.RetriveClinicalExam();
        }
      );
      this. RetriveClinicalExam();
}
openDialog(){
  if(this.patientcode !='0000' || this.patientcode != null ){
  var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')
  this.storage.store('stgVisitDate',wk_Date )
  this.storage.store('stgPatientCode',this.patientcode);

  const dialogRef = this.dialogref.open(ClinicalExamEntryComponent,
      {
        data: {
          dataKey: this.clinicalexam
        },
        width: '50vw',
        height: '30vw',
      });
    dialogRef.afterClosed().subscribe(result => {
      this.RetriveClinicalExam();
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveClinicalExam();
        dialogSubmitSubscription.unsubscribe();
      });
    }
  }
 MessegeDelete(item: ClinicalExamModel){
    this.chkuser = item.username;
    if( item.username == this.storage.retrieve('stgusername') )
      {
      swal({
            title: 'Are you sure?',
            text: 'You will not be able to recover this record!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
          }).then(
            () => {
              this.storage.store('stgPatientCode',item.patientcode);
              this.storage.store('stgVisitDate',item.examdate)
              this.userid = item.userid;
              this.DeleteClinicExam();
              swal('Deleted!', 'Your record has been deleted.', 'success');
            },
            function (dismiss) {
              if (dismiss === 'cancel') {
                swal('Cancelled', 'Your record is safe :)', 'error');
              }
            }
          );
        }
        else
        {
          this.MesgWarrning();
        }
    }
}
